import BadgeInput from './BadgeInput'

export default BadgeInput